import { render } from "./CompetencyCoursesSection.vue?vue&type=template&id=aad419cc"
import script from "./CompetencyCoursesSection.vue?vue&type=script&lang=js"
export * from "./CompetencyCoursesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__